import expensesApi from 'api/requests/expenses'
import Button from 'components/_UI/Button'
import CurrencyInputField from 'components/_UI/CurrencyInputField'
import Fieldset from 'components/_UI/Fieldset'
import Loader from 'components/_UI/Loader'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import { useEvent } from 'context/events/Event'
import date from 'helpers/date'
import fieldValidations from 'helpers/fieldValidations'
import masks from 'helpers/masks'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select';
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import buttonText from 'texts/buttons/buttonText'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function ExpensesForm({
    visible, 
    onClose, 
    onError = () => {}, 
    onSuccess = () => {},
    categories,
    importances,
    isEdit = false,
}) {
        

        const [isLoading, setIsLoading] = useState(false)

        const {event} = useEvent();

        const expensesStatus = [
            {
                name: 'Pendente',
                label: 'Pendente',
                value: 0
            },
            {
                name: 'Pago',
                label: 'Pago',
                value: 1
            },
            {
                name: 'Orcamento',
                label: 'Orçamento',
                value: 2
            },
        ]

         const importanceOptions = Object.entries(importances).map(([key, value]) => ({
            value: key,
            label: value
        }))
        const { 
            register, 
            handleSubmit, 
            control,
            setValue,
            watch,
            reset,
            formState: { errors } 
        } = useForm({
            defaultValues: !isEdit ? {
                importance: importanceOptions.find(opt => opt.label == 'Média'),
                unit: 1
            } :  {
                category: isEdit?.category,
                status: isEdit?.status,
                description: isEdit?.description,
                amount: isEdit?.amount,
                unit: isEdit?.unit,
                importance_level: isEdit?.importance,
                name: isEdit?.name,
                supplier: isEdit?.supplier,
                date: date.format(isEdit?.date)
        }});

        const categoryOptions = Object.entries(categories).map(([key, value]) => ({
            value: key,
            label: value
        }))

       

        const selectedCategory = watch("category");

        const selectedStatus = watch("status");
    
        
       


    useEffect(() => {
       
        if (!isEdit) return;

        
        if (isEdit.category) {
            const matchedCategory = categoryOptions.find(opt => opt.label === isEdit.category);
            if (matchedCategory) setValue("category", matchedCategory);
        }

        if (isEdit.importance_level) {
            const matchedCategory = importanceOptions.find(opt => opt.label === isEdit.importance_level);
            if (matchedCategory) setValue("importance_level", matchedCategory);
        }

        if (isEdit.status !== undefined && isEdit.status !== null) {
            const matchedStatus = expensesStatus.find(opt => opt.value == isEdit.status); 
            if (matchedStatus) setValue("status", matchedStatus);
        }
    }, [setValue]);


    async function createExpenses(content) {
        
        setIsLoading(true)
      
        const payload = createPayload(content);
        console.log('payload', payload)
        
        try {
            const data = await expensesApi.create(payload)
            onSuccess('criada')
        } catch (error) {
            setIsLoading(false)
            onError()
        } finally {
            setIsLoading(false)
            onClose();
        }
    }

        const createPayload = (content) => {
            const parsedAmount = parseFloat(content.amount.replace(',', '.')).toFixed(2);
            const payload = {
                event_id: event?.id,
                description: content.description,
                category: content?.category?.value,
                status: content?.status?.value,
                amount: parsedAmount,
                supplier: content?.supplier,
                unit: parseInt(content?.unit),
                importance_level: content?.importance_level?.value,
                name: content?.name,
                date: content?.date && date.unformat(content?.date)
            }
            
            if (!payload?.date || payload.date.startsWith('undefined')) {
                delete payload.date;
            }

            if(!payload.description ) {
                delete payload.description
            }

            if(!payload.unit ) {
                delete payload.unit
            }

             if(!payload.supplier ) {
                delete payload.supplier
            }

            if(!payload.importance ) {
                delete payload.importance
            }
            return payload
        }

    const handleCurrencyChange = (value) => {
        if (value) {
            const formattedValue = value.replace('.', ''); 
            return formattedValue;
        }
        return '';
    };

    async function editExpense(content) {
        setIsLoading(true)
        const payload = createPayload(content);
      
        try {
            await expensesApi.update(isEdit?.id, payload)
             onSuccess('editada')
        } catch (error) {
            setIsLoading(false)
            onError()
        } finally {
            setIsLoading(false)
            onClose();
        }
    }
    

    

  return (
    <Modal isOpen={visible} onClose={onClose} size='medium'>
        <Container>
            <Text name={'highlight'}>Despesa</Text>
                <FormContainer onSubmit={handleSubmit(!isEdit ? createExpenses : editExpense)}>
                    <ContentBasicFields>
                        <Column>
                            <Fieldset
                                label='Nome *'
                                layout='squired'
                                placeholder='Nome'
                                register={register}
                                name={'name'}
                                validations={fieldValidations.name('nome')}
                            />

                            {errors.name?.message && (
                                <Column>
                                    <Text color={colors.danger} name='small'> {errors.name?.message} </Text>
                                </Column>
                            )}
                        </Column>
                        <Column>
                            <Fieldset
                                label='Descrição (Opcional)'
                                layout='squired'
                                placeholder='Descrição'
                                register={register}
                                name={'description'}
                            />
                        </Column>
                        
                    </ContentBasicFields>

                    <ContentBasicFields>
                        <Column>
                            <Controller
                                name='amount'
                                control={control}
                                rules={{ required: 'O valor é obrigatório' }}
                                render={({ field: { onChange, value, ref } }) => (
                                    <CurrencyInputField
                                        label='Valor *'
                                        value={value}
                                        layout='squired'
                                        onChange={(value) => {
                                            const formattedValue = handleCurrencyChange(value);
                                            onChange(formattedValue); // Passa o valor formatado para onChange
                                        }}
                                        ref={ref}
                                    />
                                )}
                            />

                            {errors.amount?.message && (
                                <ErrorText name="small" color={colors.danger}>
                                    {errors.amount.message}
                                </ErrorText>
                            )}
                        </Column>

                        <ContentFieldStatus>
                            <Text paddingBottom="5px">Categoria *</Text>
                            <Column>
                                <Controller
                                name="category"
                                control={control}
                                rules={{ required: 'Selecione uma categoria' }} 
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                    <Select
                                        {...field}
                                        placeholder="Selecione"
                                        options={categoryOptions}
                                        noOptionsMessage={() => 'Nenhuma opção disponível'}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        onChange={(option) => field.onChange(option)}
                                        value={field.value}
                                    />

                                    {errors.category?.message && (  
                                        <ErrorText name="small" color={colors.danger} marginTop>
                                            {errors.category.message}
                                        </ErrorText>
                                    )}
                                    
                                    </>
                                )}
                                />
                            </Column>
                        </ContentFieldStatus>

                    </ContentBasicFields>
                    

                    <ContentBasicFields>
                        <Column>
                           <Fieldset
                                label='Unidade (Opcional)'
                                layout='squired'
                                name='unit'
                                inputType={'number'}
                                register={register}
                            />
                                
                        </Column>

                        <ContentFieldStatus>
                            <Text paddingBottom="5px">Importância (Opcional)</Text>
                            <Column>
                                <Controller
                                name="importance_level"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <Select
                                            {...field}
                                            placeholder="Selecione"
                                            options={importanceOptions}
                                            
                                            noOptionsMessage={() => 'Nenhuma opção disponível'}
                                            getOptionLabel={(option) => option.label}
                                            getOptionValue={(option) => option.value}
                                            onChange={(option) => field.onChange(option)}
                                            value={field.value}
                                        />
                                    </>
                                )}
                                />
                            </Column>
                        </ContentFieldStatus>

                    </ContentBasicFields>




                    <ContentBasicFields>
                        <ContentFieldStatus>
                            <Text paddingBottom="5px">Status *</Text>
                            <Controller
                                name="status"
                                control={control}
                                rules={{ required: 'Selecione um status' }}
                                render={({ field, fieldState: { error } }) => (
                                    <Column>
                                        <Select
                                            {...field}
                                            placeholder="Selecione"
                                            options={expensesStatus}
                                            getOptionLabel={(opt) => opt.label}
                                            getOptionValue={(opt) => opt.value}
                                            onChange={(opt) => field.onChange(opt)}
                                            value={field.value}
                                        />

                                        {errors.status?.message && (  
                                            <ErrorText name="small" color={colors.danger} marginTop>
                                                {errors.status.message}
                                            </ErrorText>
                                        )}
                                    </Column>
                                )}
                            />
                        </ContentFieldStatus>
                        
                

                        <Column>
                            <Fieldset
                                label='Data (Opcional)'
                                layout='squired'
                                placeholder='Data'
                                mask={masks.date}
                                register={register}
                                name={'date'}
                            />

                        </Column>

                    </ContentBasicFields>
                    

                    <Fieldset
                        label='Fornecedor (Opcional)'
                        layout='squired'
                        placeholder='Fornecedor'
                        register={register}
                        name={'supplier'}
                        marginTop={'10px'}
                    />

                    <ContentButtons>
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <Button
                                    variant={'light'}
                                    category={'roundedBorded'}
                                    onClick={() => {
                                        reset(); // reseta todos os campos para os valores iniciais
                                        onClose(); // fecha o modal
                                    }}
                                >
                                    {buttonText.cancel}
                                </Button>

                                <Button type='submit'>Criar</Button>
                            </>
                        )
                    }
                   </ContentButtons>


                </FormContainer>
        </Container>
    </Modal>
  )
}


const Container = styled(Column)`
    width: 100%;
    padding-top: 100px;
    padding-bottom: 40px;


    @media screen and (min-width: ${breakpoints.md}){
        padding-top: 15px;
        width: auto;
    }
`

const FormContainer = styled.form`
    text-align: center;
`;

const ContentBasicFields = styled(Column)`
   width: 100%;
   justify-content: space-around;
   margin-bottom: 10px;
    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        align-items: baseline;
        gap: 4px;
        height: 60px;
        margin-top: 10px;
        margin-bottom: 0;
    }
`

const ContentFieldStatus = styled(Column)`
  width: 100%;
  text-align: left;

  & > p {
    font-size: 12px;
    font-weight: 700;
    color: ${colors.nightDark} !important;
  }

`;



const ContentButtons = styled(Column)`
    margin-top: 40px;
    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        gap: 5px;
    }
`;
        
const ErrorText = styled.p`
  color: ${colors.danger};
  font-size: 12px;
  text-align: center !important;
  min-height: 18px;       /* espaço fixo para o erro */
  display: flex;
  justify-content: center !important;
  align-items: center !important; /* garante que o texto comece no topo */
  ${({ marginTop }) => marginTop && `
    margin-top: 8px;
  `}
`;